import { BrowserRouter } from 'react-router'
import { AppRoutes } from './routes'
import { ErrorBoundary } from '@/shared/components/error-boundary'
import { OfflineGate } from '@/shared/components/offline-gate'
import { PwaUpdatePrompt } from '@/shared/components/pwa-update-prompt'

export function App() {
  return (
    <ErrorBoundary>
      <OfflineGate>
        <BrowserRouter>
          <AppRoutes />
          <PwaUpdatePrompt />
        </BrowserRouter>
      </OfflineGate>
    </ErrorBoundary>
  )
}
